import React from 'react';
import { PrimaryButton } from '../../../components';
import sectionHeroImage1 from '../assets/sectionHero1.jpeg';
import sectionHeroImage2 from '../assets/sectionHero2.jpeg';
import sectionHeroImage3 from '../assets/sectionHero3.jpeg';
import sectionHeroImage4 from '../assets/sectionHero4.jpeg';
import sectionHeroImage5 from '../assets/sectionHero5.jpeg';
import sectionHeroImage6 from '../assets/sectionHero6.jpeg';
import sectionHeroImage7 from '../assets/sectionHero7.jpeg';
import sectionHeroImage8 from '../assets/sectionHero8.jpeg';
import sectionHeroImage9 from '../assets/sectionHero9.jpeg';
import sectionHeroImage10 from '../assets/sectionHero10.jpeg';
import sectionHeroImage11 from '../assets/sectionHero11.jpeg';
import sectionHeroImage12 from '../assets/sectionHero12.jpeg';
import sectionHeroImage13 from '../assets/sectionHero13.jpeg';
import sectionHeroImage14 from '../assets/sectionHero14.jpeg';
import sectionHeroImage15 from '../assets/sectionHero15.jpeg';
import sectionHeroImage16 from '../assets/sectionHero16.jpeg';
import sectionHeroImage17 from '../assets/sectionHero17.jpeg';
import sectionHeroImage18 from '../assets/sectionHero18.jpeg';

import css from './SectionHero.module.css';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Icons from '../../../components/Icons/Icons';

const heroImages = [
  { src: sectionHeroImage11, altId: 'SectionHero.imageAlt11' },
  { src: sectionHeroImage1, altId: 'SectionHero.imageAlt1' },
  { src: sectionHeroImage12, altId: 'SectionHero.imageAlt12' },
  { src: sectionHeroImage2, altId: 'SectionHero.imageAlt2' },
  { src: sectionHeroImage13, altId: 'SectionHero.imageAlt13' },
  { src: sectionHeroImage3, altId: 'SectionHero.imageAlt3' },
  { src: sectionHeroImage14, altId: 'SectionHero.imageAlt14' },
  { src: sectionHeroImage4, altId: 'SectionHero.imageAlt4' },
  { src: sectionHeroImage15, altId: 'SectionHero.imageAlt15' },
  { src: sectionHeroImage5, altId: 'SectionHero.imageAlt5' },
  { src: sectionHeroImage16, altId: 'SectionHero.imageAlt16' },
  { src: sectionHeroImage6, altId: 'SectionHero.imageAlt6' },
  { src: sectionHeroImage17, altId: 'SectionHero.imageAlt17' },
  { src: sectionHeroImage7, altId: 'SectionHero.imageAlt7' },
  { src: sectionHeroImage18, altId: 'SectionHero.imageAlt18' },
  { src: sectionHeroImage8, altId: 'SectionHero.imageAlt8' },
  { src: sectionHeroImage9, altId: 'SectionHero.imageAlt9' },
  { src: sectionHeroImage10, altId: 'SectionHero.imageAlt10' },
];

function SectionHero(props) {
  const { intl } = props;
  const history = useHistory();

  return (
    <div className={css.heroSection}>
      <div className={css.heroContentWrapper}>
        <div className={css.heroContent}>
          <h1>{intl.formatMessage({ id: 'SectionHero.title' })}</h1>
          <p>{intl.formatMessage({ id: 'SectionHero.description' })}</p>
          <div className={css.btnsWrapper}>
            <PrimaryButton onClick={() => history.push('/s')}>
              {intl.formatMessage({ id: 'SectionHero.getStarted' })} <Icons name="rightAngle" />
            </PrimaryButton>
          </div>
        </div>
      </div>
      <div className={css.heroGallaryWrapper}>
        <div className={css.layoutContainer}>
          {heroImages.map(image => (
            <img key={image.src} src={image.src} alt={intl.formatMessage({ id: image.altId })} />
          ))}
        </div>
      </div>
    </div>
  );
}
export default SectionHero;
